import { ActionTree } from 'vuex';
import { EDocumentsAction, EDocumentsMutation } from './documents.constants';
import { IDocumentsState } from './documents.types';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';
import { DocumentService } from '@/api/documents/services/document.service';
import { ILoadDocumentListPayload } from '@/api/documents/types/load-document-list-payload';
import { translate } from '@/helpers/translation.helper';
import { RootState } from '@/store/store';
import bugsnagClient from '@lib-shared/bugsnag';
import { IDocument } from '@lib-shared/types/Document';

export const actions: ActionTree<IDocumentsState, RootState> = {
  async [EDocumentsAction.LoadDocumentList](
    { commit, dispatch },
    payload: ILoadDocumentListPayload
  ) {
    commit(EDocumentsMutation.SetError, false);
    commit(EDocumentsMutation.SetDocuments, []);
    commit(EDocumentsMutation.SetIsLoadingDocuments, true);
    try {
      const documents: IDocument[] = await DocumentService.loadDocumentList(payload);
      dispatch(EDocumentsAction.LoadDocumentListSuccess, documents);
    } catch (e) {
      dispatch(EDocumentsAction.LoadDocumentListFailed, e);
    }
  },
  async [EDocumentsAction.LoadDocumentListSuccess]({ commit }, documents: IDocument[]) {
    commit(EDocumentsMutation.SetDocuments, documents);
    commit(EDocumentsMutation.SetIsLoadingDocuments, false);
  },
  async [EDocumentsAction.LoadDocumentListFailed]({ commit, dispatch }, e) {
    commit(EDocumentsMutation.SetError, true);
    commit(EDocumentsMutation.SetIsLoadingDocuments, false);
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowDanger}`,
      translate('could-not-load-documents'),
      {
        root: true,
      }
    );
    if (bugsnagClient) {
      bugsnagClient.notify(e);
    }
  },
  async [EDocumentsAction.LoadMoreDocuments](
    { commit, dispatch, state },
    payload: ILoadDocumentListPayload
  ) {
    const { documents } = state;
    commit(EDocumentsMutation.SetError, false);
    commit(EDocumentsMutation.SetIsLoadingDocuments, true);
    try {
      const newDocuments: IDocument[] = await DocumentService.loadDocumentList(payload);
      dispatch(EDocumentsAction.LoadDocumentListSuccess, [...documents, ...newDocuments]);
    } catch (e) {
      dispatch(EDocumentsAction.LoadDocumentListFailed, e);
    }
  },
};
